import { UseQueryResult } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { Button, Card, CardBody } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Bilancia } from '../../types'
import { calcGiorni, useIsAmministratore, useIsCliente, useIsSupervisore } from '../../utils/utils'
import { CardTable } from '../../components/StickyTable'

interface CardVerificazionePeriodicaBilanciaInterface {
  id: Bilancia['id']
  data_intervento_periodica?: Bilancia['data_intervento_periodica']
  data_scadenza_periodica?: Bilancia['data_scadenza_periodica']
  data_richiesta_periodica?: Bilancia['data_richiesta_periodica']
  intervento_aperto_periodica?: Bilancia['intervento_aperto_periodica']
}

type CardVerificazionePeriodicaBilanciaProps = {
  bilancia: UseQueryResult<CardVerificazionePeriodicaBilanciaInterface, Error>
  modalActionsAddRichiesta?: {
    open: (v?: any) => void
    close: () => void
    toggle: () => void
    onClosed: () => void
  }
  modalActionsProgrammaIntervento?: {
    open: (v?: any) => void
    close: () => void
    toggle: () => void
    onClosed: () => void
  }
  modalActionsAddInterventoVeloce?: {
    open: (v?: any) => void
    close: () => void
    toggle: () => void
    onClosed: () => void
  }
}

export default function CardVerificazionePeriodicaBilancia({
  bilancia,
  modalActionsAddRichiesta,
  modalActionsProgrammaIntervento,
  modalActionsAddInterventoVeloce,
}: CardVerificazionePeriodicaBilanciaProps) {
  const isAdmin = useIsAmministratore()
  const isSupervisore = useIsSupervisore()
  const isCliente = useIsCliente()
  return (
    <Card className="mb-3">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4">Verificazione periodica</h4>
          </div>
        </div>
        <div className="row mt-2">
          <div className={`${isCliente ? 'col-md-12' : 'col-md-9'}`}>
            <div className="bg-intervento-periodico p-2">
              <CardTable className="w-100" wrapperClassName="mobile-cards-flat">
                <thead>
                  <tr className="text-intervento-periodico">
                    <th className="p-lg">Ultimo</th>
                    <th className="p-lg">Scadenza</th>
                    <th className="p-lg">Richiesta</th>
                    <th className="p-lg">GG</th>
                    <th className="p-lg">Program.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {bilancia.data?.data_intervento_periodica
                        ? dayjs(bilancia.data?.data_intervento_periodica).format('DD.MM.YYYY')
                        : '-'}
                    </td>
                    <td>
                      {bilancia.data?.data_scadenza_periodica
                        ? dayjs(bilancia.data?.data_scadenza_periodica).format('DD.MM.YYYY')
                        : '-'}
                    </td>
                    <td>
                      {bilancia.data?.data_richiesta_periodica
                        ? dayjs(bilancia.data?.data_richiesta_periodica).format('DD.MM.YYYY')
                        : '-'}
                    </td>
                    <td>
                      {bilancia.data?.data_richiesta_periodica
                        ? calcGiorni(bilancia.data?.data_richiesta_periodica || '')
                        : '-'}
                    </td>
                    <td>
                      {bilancia.data?.intervento_aperto_periodica?.stato &&
                        bilancia.data?.intervento_aperto_periodica?.stato !== 'richiesto' && (
                          <Link
                            to={`/interventi/${bilancia.data?.intervento_aperto_periodica?.pk}`}
                            className="link-md"
                          >
                            {dayjs(bilancia.data?.intervento_aperto_periodica?.data_intervento).format('DD/MM/YYYY')}
                          </Link>
                        )}
                    </td>
                  </tr>
                </tbody>
              </CardTable>
            </div>
          </div>
          {!isCliente && (
            <div className="col-md-3">
              {!bilancia.data?.intervento_aperto_periodica?.stato &&
                !bilancia.data?.data_richiesta_periodica &&
                (isSupervisore || isAdmin) && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    className="w-100"
                    onClick={() => {
                      modalActionsAddRichiesta?.open({
                        bilancia: bilancia.data?.id,
                        tipo_intervento: 'verifica_periodica',
                        stato: 'richiesto',
                        data_richiesta: dayjs().format('YYYY-MM-DD'),
                        note: '',
                      })
                    }}
                  >
                    Aggiungi richiesta
                  </Button>
                )}
              {bilancia.data?.intervento_aperto_periodica?.stato === 'richiesto' &&
                bilancia.data?.data_richiesta_periodica &&
                (isSupervisore || isAdmin) && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    className="w-100"
                    onClick={() => {
                      modalActionsProgrammaIntervento?.open(bilancia.data?.intervento_aperto_periodica)
                    }}
                  >
                    Pianifica intervento
                  </Button>
                )}
              {!bilancia.data?.intervento_aperto_periodica?.stato && !bilancia.data?.data_richiesta_periodica && (
                <Button
                  size="sm"
                  variant="secondary text-white"
                  className="w-100 mt-2"
                  onClick={() => {
                    modalActionsAddInterventoVeloce?.open({
                      bilancia: bilancia.data?.id,
                      tipo_intervento: 'verifica_periodica',
                      stato: 'programmato',
                      data_intervento: dayjs().format('YYYY-MM-DD'),
                      data_richiesta: dayjs().format('YYYY-MM-DD'),
                      note: '',
                    })
                  }}
                >
                  Intervento veloce
                </Button>
              )}
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  )
}
